import React, { useEffect, useState } from 'react'
import { IUbicacionCommand } from '../../../../../../Interfaces/auxiliar/IUbicacion';
import { IPanelUbicacion } from './PanelUbicacionCrear';
import { codigosRespuesta, IResponseApiFluent } from '../../../../../../Interfaces/base/IResponse';
import { IComboBoxOption } from '@fluentui/react';
import UbicacionService from '../../../../../../services/auxiliar/UbicacionService';

const UsePanelUbicacionCrear = (props: IPanelUbicacion) => {

    const initial: IUbicacionCommand = {
        nombre: "",
        codigo: "",
        nivel: props.nivel ?? 0
    }

    const [command, setCommand] = useState<IUbicacionCommand>(initial);
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [estados, setEstados] = useState<IComboBoxOption[]>([])

    const postInsertarUbicacion = () => {
        setLoading(true)
        UbicacionService.CreateUbicacion(command)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        cerrarPanel()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    console.log('Error detallado:', e);
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const cerrarPanel = () => {
        setMensaje("")
        setCommand(initial)
        setStatus(0)
        props.onDismiss()
    };

    const required: (keyof IUbicacionCommand)[] = [
        "codigo",
        "nivel",
        "nombre"
    ];

    useEffect(() => {
        const check = required.every((field) => {
            const value = command[field];
            return value !== null && value !== undefined && value !== "";
        });
        setDisableForm(!check)
    }, [command])

    return { command, setCommand, postInsertarUbicacion, loading, disableForm, cerrarPanel, mensaje, status, estados }
}

export { UsePanelUbicacionCrear }